<template>
  <v-row style="max-width: 600px; margin: 0 auto;">
    <v-col id="base" md="12" style="display: flex; flex-flow: column; height: 100%;" class="mt-0 pt-0" >
      <!-- Header -->
      <v-row justify="center" align="start" style="background-color: white; border-bottom: 3px solid #E8E8E8; height: 80px">
        <v-col class="ml-4 mt-0 pt-1 RestoRegular">
          <v-row  style="font-size: 18px; color: #4D4D4D; max-width: 300px" class="pt-2">Por favor agrega tu método de pago</v-row>
          <!-- <v-snackbar v-model="isError" :top="true" color="error">¡Falta llenar algún campo!</v-snackbar>
          <v-snackbar
            v-model="isError2"
            :top="true"
            color="error"
          >¡Error! Por favor verifica tu número de cuenta y tu CVV</v-snackbar>
          <v-snackbar v-model="alert" :top="true" color="error">{{ alertmensaje }}</v-snackbar> -->
        </v-col>
      </v-row>

      <!-- New content -->
      <v-row style="flex-grow : 1;" class="py-0 my-0" >
          <v-col style="height: 100%" class="py-0 my-0">
              <form action id="form-pagar-mp" style="height: 100%">
                  <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="card.name" :rules="[rules.required]" label="Nombre que aparece en la tarjeta" outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                        <input data-checkout="cardholderName" id="" v-model="card.name" type="text" v-show="false"/>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <v-text-field v-model="card.num" data-checkout="cardNumber" id="cardNumber" name="cardNumber" type="text" :rules="[rules.required,rules.card]" label="Número de tarjeta" @keyup="print()" outlined class="mt-1 mb-2" hide-details='true'></v-text-field>
                        <!-- <input data-checkout="cardNumber" id="cardNumber" name="cardNumber" type="text" v-model="card.num" v-show="true"/> -->
                    </v-row>
                    <v-row style="margin: 0 auto; max-width: 350px;" class="my-0 py-0">
                        <v-col class="pl-0">
                            <v-text-field v-model="card_exp" label="Expiración" placeholder="mm/aa" :rules="[rules.required,rules.exp]" id="dateexp" class="mt-1 mb-2" hide-details='true' outlined></v-text-field>
                             <input v-model="year" id="cardExpirationYear" data-checkout="cardExpirationYear" v-show="false" type="text" />
                             <input v-model="month" id="cardExpirationMonth" data-checkout="cardExpirationMonth" v-show="false" type="text" />
                        </v-col>
                        <v-col class="pr-0">
                            <v-text-field
                                v-model="card.cvv"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPassword ? 'text' : 'password'"
                                label="CVV"
                                :rules="[rules.required,rules.cvv]"
                                outlined
                                id="cvv4"
                                class="mt-1 mb-2"
                                hide-details='true'
                                @click:append="showPassword = !showPassword"
                            ></v-text-field>
                            <input v-model="card.cvv" id="securityCode" data-checkout="securityCode" v-show="false" type="text" />
                        </v-col>
                    </v-row>
                    <v-row style="max-width: 350px; margin: 0 auto;">
                        <br><br>
                        <p>
                            <input type="hidden" name="payment_method_id" id="payment_method_id"/>
                            <input type="submit" value="Realizar Pago" />
                        </p>
                    </v-row>
                    
              </form>
          </v-col>
      </v-row>
      <v-row justify="center" style="max-height: 70px; margin: 0 auto; width: 100%"  >
          <v-btn @click="$router.push({ name: 'finalOrder'}); " class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 94%; height: 55px;  ">
              <span style="float: left; padding-left:0px;">Regresar</span>
              <v-spacer></v-spacer>
          </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import $ from "jquery";
require("jquery-mask-plugin");
import axios from "axios";

export function dateMask(value) {
  const hours = [/[0-1]/, value.charAt(0) === "0" ? /[1-9]/ : /[0-2]/];
  const minutes = [/[0-9]/, /[0-9]/];
  return value.length > 2 ? [...hours, "/", ...minutes] : hours;
}
export function rangeMask(value) {
  const numbers = value.replace(/[^0-9]/g, "");
  return [...dateMask(numbers)];
}

export default {
  data() {
    return {
      month:'',
      year:'',  
      showPassword: false,
      mask: rangeMask,
      card_exp: null,
      card: {
        _id: "",
        alias: "",
        name: "",
        num: "",
        exp: "",
        cvv: "",
        token:"",
      },
      rules: {
        card: v =>
          v
            ? (v.length >= 18 && v.length <= 19) ||
              "Minimo 15 caracteres máximo 16"
            : true,
        exp: v => (v ? v.length >= 5 || "Coloca la expiración completa" : true),
        cvv: v =>
          v
            ? (v.length >= 3 && v.length <= 4) || "Minimo 3 caracteres máximo 4"
            : true,
        required: value => !!value || ""
      },
      isError: false,
      isError2: false,
      alert: false,
      alertmensaje: "Ocurrió un error"
    };
  },
  mounted() {
    var that = this;  
    window.Mercadopago.setPublishableKey(
      "TEST-2cb81ee9-78d3-4d40-8f4a-315b3ab2e363"
    );
    // document.getElementById("cardNumber").addEventListener("keyup", guessPaymentMethod);
    document.getElementById("cardNumber").addEventListener("input", guessPaymentMethod);

    // const selectElement = document.querySelector('cardNumber');

    // selectElement.addEventListener('change', (event) => {
    //     console.log(event, "HOLA");
    // });
    
    $("#form-pagar-mp").submit(function(event) {
      //console.log('Crear pago');
      event.preventDefault();
      console.log("Crear pago");
      var $form = $(this);
      window.Mercadopago.createToken($form, mpResponseHandler);
      return false;
    });

    function guessPaymentMethod(event) {
        console.log(event)
        console.log(document.getElementById("cardNumber").value)
      let cardnumber = document.getElementById("cardNumber").value;
      console.log(cardnumber.length);
      if (cardnumber.length >= 6) {
        // console.log("QUEDADA");
        let bin = cardnumber.substring(0, 6);
        window.Mercadopago.getPaymentMethod(
          {
            bin: bin
          },
          setPaymentMethod
        );
      }
    }

    function setPaymentMethod(status, response) {
        console.log(response)
      if (status == 200) {
        let paymentMethodId = response[0].id;
        let element = document.getElementById("payment_method_id");
        element.value = paymentMethodId;
        that.card.alias = response[0].name;
      } else {
        alert(`payment method info error: ${response}`);
      }
    }

    var mpResponseHandler = function(status, response) {
      var $form = $("#form-pagar-mp");
      if (response.error) {
        console.log(response);
      } else {
        var card_token_id = response.id;
        $form.append(
          $(
            '<input type="hidden" id="card_token_id" name="card_token_id"/>'
          ).val(card_token_id)
        );
        console.log("card_token_id: " + card_token_id);
        that.card.token = card_token_id;
        that.goTo();
      }
    };

    $("document").ready(function() {
      $("#cardNumber").mask("0000-0000-0000-0000");
      $("#cvv4").mask("0000");
      // var options =  {
      //     onKeyPress: function(cep, e, field, options) {
      //         var masks = ['00000-000', '0-00-00-00'];
      //         var mask = (cep.length>7) ? masks[1] : masks[0];
      //         $('#dateexp').mask(mask, options);
      //     }
      // };
      $("#dateexp").mask("ab-00", {
        translation: {
          a: {
            pattern: /[0-1]/
          },
          b: {
            pattern: /[1-9]/
          },
          c: {
            pattern: /[0-2]/
          }
        },
        onKeyPress: function(cep, e, field, options) {
          var masks = ["ab-00", "ac-00"];
          var mask = cep[0] == 1 ? masks[1] : masks[0];
          $("#dateexp").mask(mask, options);
        }
      });
    });
  },
  watch:{
        card_exp()
        {
            if(this.card_exp.length == 5 )
            {
                this.month=this.card_exp.substr(0,2);
                this.year=this.card_exp.substr(3,4);
                console.log(this.month);
                console.log(this.year);
            }
        }

  },
  methods: {
    async goTo() {
      // console.log("QUEDÉ", this.card);
      if (
        !!this.card.alias &&
        !!this.card.name &&
        !!this.card.num &&
        !!this.month &&
        !!this.year &&
        !!this.card.cvv
      ) {
        // console.log("QUEDÉ x2");
        if (
          (this.card.num.length == 19 && this.card.cvv.length == 3) ||
          (this.card.num.length == 18 && this.card.cvv.length == 4)
        ) {
          var cardTemp = {
            id_cliente: null,
            alias: null,
            id_sucursal:null,
            token_tc: null
          };
          console.log("ID_CLIENTE: ", this.$store.state.id_cliente);
          cardTemp.id_cliente = this.$store.state.id_cliente;
          cardTemp.alias = this.card.alias;
          cardTemp.token_tc = this.card.token;
          cardTemp.id_sucursal=localStorage.getItem("id_sucursal");
          await axios
            .post(
              " /alta_cuenta",
              cardTemp,
              { headers: { Authorization: this.$store.state.token } }
            )
            .then(res => {
              console.log("Respuesta: ", res);
              console.log("Mensaje: ", res.data.mensaje);
              if (res.data.mensaje == "Cuenta creada") {
                this.$router.push({ name: "finalOrder" });
              } else {
                this.alertmensaje = res.data.mensaje;
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = this.alertmensaje;
                this.$store.state.alertColor = "warning";
                setTimeout(() => {
                this.$store.state.alertState = false;
                }, 4000);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          this.$store.state.alertState = true;
          this.$store.state.alertMessage = "¡Error! Por favor verifica tu número de cuenta y tu CVV";
          this.$store.state.alertColor = "error";
          setTimeout(() => {
          this.$store.state.alertState = false;
          }, 4000);
        }
      } else {
        this.$store.state.alertState = true;
        this.$store.state.alertMessage = "Falta llenar algún campo";
        this.$store.state.alertColor = "error";
        setTimeout(() => {
        this.$store.state.alertState = false;
        }, 4000);
      }
    },
    disablePlease() {
      return this.card.name == "" ||
        this.card.num == "" ||
        this.card.exp == "" ||
        this.card.cvv == ""
        ? true
        : false;
    },
    print() {
      // console.log("EL COSO: ", this.card.num.length);
    }
  },
  created() {
        this.$store.state.hideFooter = false;
  }
};
</script>

<style scoped>
.btnDisabled:enabled {
  opacity: 1;
}

.btnDisabled:disabled {
  opacity: 0.7;
}
</style>